// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8932) return "static/chunks/8932-8e0f0a6bd27c9265.js";
	if (chunkId === 2204) return "static/chunks/2204-95ec2b5229232b08.js";
	if (chunkId === 6209) return "static/chunks/6209-55cee33ac976ae33.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"268":"57c5ac6ddbfae66d","359":"e0720b278f73a9c7","3920":"807810362eed38f2"}[chunkId] + ".js";
};